import {
  index as baseIndex,
  getFromId as baseGetFromId,
  editFromId as baseEditFromId,
  newItem as baseNewItem
 } from './Base';

/******************************************************************************
 * INDEX FUNCTION                                                             *
 ******************************************************************************/

/**
 * Get a list of alphalink_mobile_products based on a pagination system
 *
 * @param page the page requested
 * @param itemPerPage the number of item in the page requested
 */
export function index(page = 1, itemPerPage = 10, search = {}, order = 'ASC', scheme = null){
  return baseIndex('alphalink_mobile_products', page, itemPerPage, search, order, scheme);
}

/******************************************************************************
 * GETTER FUNCTION                                                            *
 ******************************************************************************/

/**
 * Get a single alphalink_mobile_product based on his ID
 *
 * @param id the of the alphalink_mobile_product requested
 */
export function getFromId(id) {
  return baseGetFromId('alphalink_mobile_products', id);
}

/**
 * Get a single alphalink_mobile_product based on his ID
 *
 * @param id the of the alphalink_mobile_product requested
 */
export function getIdentificationFromId(id) {
  return baseGetFromId('alphalink_mobile_products', id, 'identification');
}

/******************************************************************************
 * SETTER FUNCTION                                                            *
 ******************************************************************************/

/**
 * Edit a single alphalink_mobile_product based on his ID
 *
 * @param id the of the alphalink_mobile_product requested
 * @param data the new data of the alphalink_mobile_product
 */
export function editFromId(id, data) {
  return baseEditFromId('alphalink_mobile_products', id, data);
}

/******************************************************************************
 * NEW FUNCTION                                                               *
 ******************************************************************************/

/**
 * Create a new alphalink_mobile_product
 *
 * @param data the new data of the alphalink_mobile_product
 */
export function newItem(data) {
  return baseNewItem('alphalink_mobile_products', data);
}

/******************************************************************************
 * FETCH FUNCTION                                                             *
 ******************************************************************************/

/**
 * Fetch all alphalink_mobile_products to serve in a dropdown form choice
 */
export function fetchAlphalinkMobileProducts(search = []) {
  return baseIndex('alphalink_mobile_products', 1, 0, search, 'ASC');
}
